<div class="notice-card">
  @switch (notice.noticeTypeId) {
  @case (NoticeType.UnreadMessages) {
  <div class="notice-title">
    <i class="fas fa-bell" style="margin-right: 6px;"></i>
    {{ notice.unreadMessage?.unreadCount ?? notice?.unreadCount }} Conversation(s) with New Message(s)
  </div>
  <div class="notice-content">
    {{ notice.unreadMessage?.financialCommunityName }} {{ notice.unreadMessage?.lotBlock }}
  </div>
  <div>
    Go to
    <a href="" (click)="onGoToLotMessages($event, notice.unreadMessage)">
      Lot Customer Messages
    </a>
  </div>
  }
  @case (NoticeType.OverDueConstructionUpdates) {
  <p-button type="button" class="notice-dismiss" [text]="true" [rounded]="true" severity="secondary"
    pTooltip="Dismiss Notice" (onClick)="onDismiss()">
    <i class="fas fa-times"></i>
  </p-button>
  <div class="notice-title">
    Past Due Construction Update
  </div>
  <div class="notice-content">
    {{ notice?.constructionUpdate?.communityName }}-{{ notice?.constructionUpdate?.lotBlock }}
  </div>
  <div>
    Go to
    <a href="" (click)="onGoToLotConstructionUpdates($event, notice?.noticeId, notice)">
      Lot Construction Updates
    </a>
  </div>
  }
  @default {
  }
  }
</div>
